
import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { TreeviewComponent, TreeviewConfig, TreeviewI18n, TreeviewItem } from '@soy-andrey-semyonov/ngx-treeview';
import { Subscription } from 'rxjs';
import { SimpleDataTreeviewI18n } from 'src/app/forms/simple-datatree/simple-datatree-i18n';
import { GenericEdit } from 'src/app/interfaces/generic-edit';
import { HTTPService } from 'src/app/services/http.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';

export class ItemCategory{
    text:string;
    value:string;
    children:ItemCategory[];
}

@Component({
    selector: 'app-amazon-search-category',
    templateUrl: './amazon-search-category.component.html',
    styleUrls: ['./amazon-search-category.component.scss'],
    providers: [{ provide: TreeviewI18n, useClass: SimpleDataTreeviewI18n }],
    standalone: false
})
export class AmazonSearchCategoryComponent implements OnInit, OnDestroy {
  codecompany: any;
  sub:Subscription;
  lista:TreeviewItem[];
  buttonList:ButtonList[] = [];
  rows: Object[] = [];
  browseNodeId:any;

  data:GenericEdit;
  @Input() product:Object;
  @Output() saving:EventEmitter<boolean> = new EventEmitter();
  
  @ViewChild(TreeviewComponent, { static: false }) treeviewComponent: TreeviewComponent;
  
  config = {
    hasAllCheckBox: false,
    hasFilter: true,
    hasCollapseExpand: true,
    decoupleChildFromParent: true,
    hasDivider:true
  }
  selectedTipoProduto: any;
  selectedBrowseNodeId: any;
  selectedId:any;
  

  constructor(private http:HTTPService, private uid:UserAuthenticationServices ,
    @Inject(MAT_DIALOG_DATA) public dataDialog, public dialogRef:MatDialogRef<any>, private spinner:NgxSpinnerService,
    private formBuilder:FormBuilder) { }


  onSelectedChange(evento:TreeviewItem){
      
  }

  onFilterChange(evento){

  }

  async onClickLine(evento:TreeviewItem){
    this.selectedId = evento.value;

    if ( !evento.children ){
      let code = evento.value;
      let row = this.rows.find(data=>data['CODCATEGORIA']==code);
      this.selectedTipoProduto = row['TIPO_PRODUTO'];
      this.selectedBrowseNodeId = code;
      this.dataDialog.get('BROWNSENODEID').setValue(code);
      this.dataDialog.get('OPTIONDATA').setValue(this.selectedTipoProduto);
      this.dataDialog.get('CATEGORY').setValue(code);
      await this.loadInfosAmazon();
      this.dialogRef.close();
    }
  }
  loadInfosAmazon() {
    return new Promise((resolve,reject)=>{
        resolve(true);
    });
  }

  okFunction(){
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.buttonList.push({
      color:"warn",
      description:"Sair",
      action: ()=>{
          this.okFunction();
      }
    })
    
    this.codecompany = (this.dataDialog as UntypedFormGroup).get("CODECOMPANY").value;
    if ( this.codecompany == null ){
        this.dialogRef.close();
        throw  Error("Selecionar a empresa para buscar categorias.");
    }
    this.findCategories();
  }

  findCategories(){
    this.spinner.show('searchAmazonCategory');
    let jsonDec:Object ={
      "entityName":"Mktpamazoncategory",
      "sql":"SELECT CODCATEGORIA,NOME,GRAU,CODCATEGORIAPAI,TIPO_PRODUTO FROM MKTPAMAZONCATEGORY"
    };


    this.sub = this.http.post(jsonDec,"JsonBrokerServices/findnative",false).subscribe(
      {
        next: (data)=>{
          this.rows = data['SQL'];
          this.transformData(this.rows);
        },
        error: (error)=>{
          this.spinner.hide('searchAmazonCategory');
          throw error;
        },
        complete:()=>{
          this.spinner.hide('searchAmazonCategory');
        }
      }
    );
  }

  findParent(value:number, children:TreeviewItem[]):TreeviewItem{

    var item;
    
    for ( var i:number = 0; i < children.length; i++ ){
        if ( children[i].value == value ){
          return children[i];
        }else{
            if (children[i].children && children[i].children.length) {
              item = this.findParent(value,children[i].children);
            }
            if ( item ){
              return item;
            }
        }
    }
    
    return item;
  }


  transformData(rows:Object[]):void{
    
    this.lista = [];
        
    rows.sort((a:Object,b:Object)=>{

      if (a['NOME'] < b['NOME']  ) return -1;
        if (a['NOME'] > b['NOME']  ) return 1;
        return 0;
    });
    
    if ( rows.length > 0 ){
        rows.filter(a=>a['CODCATEGORIAPAI']=="-999999999").forEach(pai=>{          
          let code = pai['CODCATEGORIA'];
          let name = pai['NOME'];
          let item = new TreeviewItem({text:code + " - " +name, value:code,checked:false,collapsed:true });
          this.checkChild(rows,code,item);
          this.lista.push(item);
        });
    }
  }

  
  checkChild(rows:Object[],  pai:string, item:TreeviewItem):void{

      let newArray:Object[] = rows.filter(data=> data['CODCATEGORIAPAI'] == pai );
  
      if ( newArray.length > 0 ){
        for ( var child of newArray ){
          let code = child['CODCATEGORIA'];
          let name = child['NOME'];
          let dataItem:TreeviewItem = new TreeviewItem({text:code + ' - '+ name, value:code, collapsed:true, checked: false, children:[] });
          if ( item.children == null ){
            item.children = [ dataItem ];
          }else{
            item.children.push(dataItem)
          }
          
          let has_children = rows.filter(data=> data['CODCATEGORIAPAI'] == code ).length > 0;
          if ( has_children){
            this.checkChild(rows,code,dataItem);
          }
      }
    } 
  }
  
  ngOnDestroy(){
    if ( this.sub!= null ){ this.sub.unsubscribe()};
  }

}
